<!-- prodList -->
<div class="prodList container">
    <h2 class="b-tit">What's New✨</h2>
    <products [products]="products" [config]="config" [urlWownet]="urlWownet"></products>
</div>
<!-- //prodList -->